import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/Sounds/the-scream-and-chirp-of-the-taui.mp3';
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useBirdState } from '@/composables/useBirdState';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SimpleBird',
    setup(__props) {
        const router = useRouter();
        const { catchBird } = useBirdState();
        const isVisible = ref(false);
        const progress = ref(0);
        const birdRef = ref();
        const chirpAudio = ref();
        const audioUnlocked = ref(false);
        let animationFrame = null;
        let startTime = 0;
        let intervalId = null;
        const birdStyle = computed(() => {
            if (!isVisible.value) {
                return { display: 'none' };
            }
            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight;
            if (screenWidth === 0 || screenHeight === 0) {
                return { display: 'none' };
            }
            const x = screenWidth * (1 - progress.value);
            const centerY = screenHeight / 2;
            const y = centerY + 80 * Math.sin(1.5 * 2 * Math.PI * progress.value);
            return {
                transform: `translate(${x}px, ${y}px)`,
                position: 'fixed',
                left: '0',
                top: '0',
                width: '64px',
                height: '64px',
                cursor: 'pointer',
                zIndex: '9999',
                pointerEvents: 'auto',
                filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.2))'
            };
        });
        const silentUnlock = () => {
            if (audioUnlocked.value || !chirpAudio.value)
                return;
            const audio = chirpAudio.value;
            audio.volume = 0;
            audio.play()
                .then(() => {
                audio.pause();
                audio.currentTime = 0;
                audio.volume = 0.7;
                audioUnlocked.value = true;
            })
                .catch((error) => {
                console.log(error);
            });
        };
        const playChirpSound = () => {
            if (!chirpAudio.value || !audioUnlocked.value)
                return;
            try {
                chirpAudio.value.currentTime = 0;
                chirpAudio.value.volume = 0.7;
                chirpAudio.value.load();
                chirpAudio.value.play()
                    .catch(error => {
                    console.log(error);
                });
            }
            catch (error) {
                console.log(error);
            }
        };
        const animate = (timestamp) => {
            if (!startTime)
                startTime = timestamp;
            const elapsed = timestamp - startTime;
            progress.value = Math.min(elapsed / 4000, 1);
            if (progress.value < 1) {
                animationFrame = requestAnimationFrame(animate);
            }
            else {
                isVisible.value = false;
                progress.value = 0;
                startTime = 0;
                animationFrame = null;
            }
        };
        const startFlight = () => {
            if (isVisible.value)
                return;
            isVisible.value = true;
            progress.value = 0;
            startTime = 0;
            playChirpSound();
            if (animationFrame) {
                cancelAnimationFrame(animationFrame);
            }
            animationFrame = requestAnimationFrame(animate);
        };
        const handleClick = () => {
            catchBird();
            isVisible.value = false;
            progress.value = 0;
            startTime = 0;
            if (animationFrame) {
                cancelAnimationFrame(animationFrame);
                animationFrame = null;
            }
            router.push('/congratulations');
        };
        onMounted(() => {
            if (chirpAudio.value) {
                chirpAudio.value.load();
            }
            const events = ['click', 'touchstart', 'keydown', 'scroll', 'mousemove'];
            events.forEach(event => {
                document.addEventListener(event, silentUnlock, { once: true });
            });
            setTimeout(() => {
                startFlight();
            }, 180000);
            intervalId = window.setInterval(startFlight, 180000);
        });
        onUnmounted(() => {
            if (intervalId)
                clearInterval(intervalId);
            if (animationFrame)
                cancelAnimationFrame(animationFrame);
            if (chirpAudio.value) {
                chirpAudio.value.pause();
                chirpAudio.value.currentTime = 0;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createElementVNode("audio", {
                    ref_key: "chirpAudio",
                    ref: chirpAudio,
                    preload: "auto"
                }, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("source", {
                            src: _imports_0,
                            type: "audio/mpeg"
                        }, null, -1)
                    ]))], 512),
                (isVisible.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        ref_key: "birdRef",
                        ref: birdRef,
                        class: "bird",
                        style: _normalizeStyle(birdStyle.value),
                        onClick: handleClick
                    }, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("svg", {
                                class: "bird-svg",
                                viewBox: "0 0 512 512",
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-hidden": "true",
                                preserveAspectRatio: "xMidYMid meet"
                            }, [
                                _createElementVNode("path", {
                                    fill: "#2B3B47",
                                    d: "M120.965 227.598c-22.179 1.905-39.631 20.262-39.631 42.885c0 22.686 17.452 41.043 39.631 42.976v.522h60.887v-.185h.17c23.911 0 43.312-19.401 43.312-43.312s-19.401-43.312-43.312-43.312c-.047 0-.079.091-.17.091v-.091h-60.887v.426z"
                                }),
                                _createElementVNode("path", {
                                    fill: "#ADBCBB",
                                    d: "M342.806 88.829C341.459 80.115 355 69.147 355 69.147A2.147 2.147 0 0 0 352.853 67h-39.38c-1.596 0-2.634-1.679-1.92-3.107l5.48-10.96c.802-1.605-.593-3.43-2.35-3.063c-12.299 2.565-51.739 14.027-89.985 30.758c-17.707 5.925-34.344 14.895-49.476 26.226c-11.825 7.924-21.587 16.366-27.716 25.13l.009-.002c-35.468 38.585-57.606 91.326-57.606 143.974c0 101.526 82.303 183.829 183.829 183.829s183.829-82.303 183.829-183.829c-.001-77.094-47.465-154.386-114.761-187.127z"
                                }),
                                _createElementVNode("path", {
                                    fill: "#E5E4DF",
                                    d: "M309.365 247c-2.832-32.971-30.121-58.914-63.751-58.914c-33.723 0-61.013 25.943-63.886 58.914l-.776 41.426h.276v.252c0 35.546 28.84 64.386 64.386 64.386S310 324.224 310 288.679c0-.07-.135-.117-.135-.252H310V247h-.635z"
                                }),
                                _createElementVNode("path", {
                                    fill: "#2B3B47",
                                    d: "M269.263 256.567c-1.054-12.276-11.215-21.935-23.736-21.935c-12.556 0-22.717 9.659-23.787 21.935h-.289v33.7h.103v.094c0 13.235 10.738 23.973 23.973 23.973s23.973-10.738 23.973-23.973c0-.026-.05-.043-.05-.094h.05v-33.7h-.237z"
                                }),
                                _createElementVNode("path", {
                                    fill: "#D1CFC3",
                                    d: "M112.6 286.502c31.605 0 62.185 75.77 50.569 87.386s-96.428 9.162-124.523 0c-28.561-9.314 57.539-87.386 73.954-87.386z"
                                })
                            ], -1)
                        ]))], 4))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
